import axios from 'axios';
import { postData } from './axiosUtils';

const imageService = {
  list: (publisherId: any) => {
    return axios
      .get(`/api/image/list?publisherId=${publisherId}`)
      .then((response) => {
        return response.data;
      });
  },
  get: (id: any) => {
    return axios.get(`/api/image/details/${id}`).then((response) => {
      return response.data;
    });
  },
  create: (entity: any) => {
    return postData({
      url: `/api/image/create`,
      data: entity,
    }).then((response) => {
      return response;
    });
  },
  update: (entity: any) => {
    return postData({
      url: `/api/image/update`,
      data: entity,
      method: 'PUT',
    }).then((response) => {
      return response;
    });
  },
  delete: (id: any) => {
    return postData({
      url: `/api/image/delete/${id}`,
      method: 'DELETE',
    }).then((response) => {
      return response;
    });
  },
  deduplicate: () => {
    return postData({
      url: `/api/image/deduplicate`,
    }).then((response) => {
      return response;
    });
  },
  regenerateThumbnails: (forceAll = true) => {
    return postData({
      url: `/api/image/regenerate-thumbnails?forceAll=${forceAll}`,
    }).then((response) => {
      return response;
    });
  },
};

export default imageService;
